/**
 * @architecture-header 1
 * @layer shared
 * @domain workspace
 * @responsibility Narrow untrusted transport errors by HTTP status without coupling views to one client error class.
 * @state-owner none
 * @allowed-imports none
 * @forbidden React; API calls; module policy
 * @public-api workspace package internals
 * @side-effects none
 * @tests pnpm --filter @vispo/workspace-web test
 */

export function hasHttpStatus(error: unknown, status: number): boolean {
  return Boolean(
    error &&
      typeof error === 'object' &&
      'status' in error &&
      typeof error.status === 'number' &&
      error.status === status,
  );
}
